import { useState, useEffect } from 'react';
import './Login.css';
import { FiMail, FiLock, FiEye, FiEyeOff, FiArrowLeft, FiMessageSquare } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { notify } from '../../components/Notify';
import { loginEstudanteApi, esqueciSenhaApi } from '../../Api';
import Cookies from "js-cookie";
import { useStorageValidarCarteira } from './StorageValidarCarteira';
import fundoeduc1 from '../../assets/fundoeduc1.png';
import logo_iti from '../../assets/logo_iti.png';
import Footer from '../../components/Footer';
import { whatsappUrl } from '../../config';

const ATENDENTE_MSG = 'Olá! Preciso de ajuda com minha carteirinha estudantil UNAE.';

const Login = () => {
    const [mode, setMode] = useState('login'); // 'login' | 'forgot'
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [showSenha, setShowSenha] = useState(false);
    const [loading, setLoading] = useState(false);

    const [forgotEmail, setForgotEmail] = useState('');
    const [forgotLoading, setForgotLoading] = useState(false);

    const navigate = useNavigate();
    const { setCurrentUser } = useStorageValidarCarteira(state => state).dispatch;
    const expirationTime = 1;

    // Já logado? Vai direto pra carteira.
    useEffect(() => {
        if (Cookies.get("usuario") && Cookies.get("cpf") && Cookies.get("user_id")) {
            navigate('/visualizaminhacarteira', { replace: true });
        }
    }, [navigate]);

    const handleLogin = () => {
        if (loading) return;
        const emailTrim = email.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTrim)) return notify('Informe um email válido.');
        if (!senha) return notify('Informe sua senha.');

        setLoading(true);
        loginEstudanteApi({ email: emailTrim, senha })
            .then(resp => {
                if (resp?.data?.status === false) {
                    setLoading(false);
                    return notify(resp?.data?.message || 'Email ou senha incorretos.');
                }
                setCurrentUser({ ...resp?.data });
                Cookies.set("usuario", "true", { expires: expirationTime });
                Cookies.set("cpf", resp?.data?.cpf, { expires: expirationTime });
                Cookies.set("user_id", resp?.data?.id, { expires: expirationTime });
                if (resp?.data?.token) Cookies.set("token", resp.data.token, { expires: expirationTime });
                navigate('/visualizaminhacarteira');
            })
            .catch(() => {
                setLoading(false);
                notify('Erro ao conectar com o servidor.');
            });
    };

    const handleForgot = () => {
        if (forgotLoading) return;
        const emailTrim = forgotEmail.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTrim)) return notify('Informe um email válido.');

        setForgotLoading(true);
        esqueciSenhaApi({ email: emailTrim })
            .then(() => {
                notify('Se o email estiver cadastrado, enviamos um link de redefinição.');
                setMode('login');
                setForgotEmail('');
            })
            .catch(() => notify('Erro ao solicitar redefinição. Tente novamente.'))
            .finally(() => setForgotLoading(false));
    };

    const falarComAtendente = () => {
        window.open(whatsappUrl(ATENDENTE_MSG), '_blank');
    };

    return (
        <>
            <div className="container" style={{ backgroundImage: `url(${fundoeduc1})` }}>
                <div className="login-wrapper">

                    {/* LADO VISUAL */}
                    <div className="visual-side">
                        <div>
                            <div className="badge">Portal Oficial UNAE</div>
                            <h2>Sua identidade estudantil, agora digital.</h2>
                            <p>Acesse o ecossistema UNAE e gerencie sua carteira com segurança e agilidade.</p>
                        </div>

                        <div className="side-illustration">
                            <img src={`${process.env.PUBLIC_URL}/unaeBrasao.png`} alt="Brasão UNAE" className="logo-img2" />
                        </div>

                        <div className="benefit-item">
                            <span className="benefit-icon"><img style={{ height: '52px', width: 'auto' }} src={logo_iti} alt="ITI" /></span>
                            <div>
                                <strong>Validação Oficial</strong>
                                <p>Padrão nacional ITI/Meia-Entrada.</p>
                            </div>
                        </div>
                    </div>

                    {/* LADO DO FORMULÁRIO */}
                    <div className="form-side">
                        <div className="brand-area">
                            <img
                                src={`${process.env.PUBLIC_URL}/nomeUnae.png`}
                                alt="UNAE Estudantil"
                                style={{ height: '60px', width: 'auto' }}
                            />
                        </div>

                        {mode === 'login' ? (
                            <>
                                <div className="header-text">
                                    <h2 style={{ textAlign: 'center' }}>Bem-vindo</h2>
                                    <p className="subtitle" style={{ textAlign: 'center' }}>Entre com seu email e senha.</p>
                                </div>

                                <div className="formContainer">
                                    <div className="input-container">
                                        <label htmlFor="email">Email</label>
                                        <div className="custom-input-wrapper">
                                            <input
                                                id="email"
                                                type="email"
                                                placeholder="seuemail@exemplo.com"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                                            />
                                            <span className="input-icon"><FiMail size={20} /></span>
                                        </div>
                                    </div>

                                    <div className="input-container">
                                        <label htmlFor="senha">Senha</label>
                                        <div className="custom-input-wrapper">
                                            <input
                                                id="senha"
                                                type={showSenha ? 'text' : 'password'}
                                                placeholder="Sua senha"
                                                value={senha}
                                                onChange={(e) => setSenha(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                                                style={{ paddingRight: '44px' }}
                                            />
                                            <span className="input-icon"><FiLock size={20} /></span>
                                            <button
                                                type="button"
                                                className="senha-toggle"
                                                onClick={() => setShowSenha(s => !s)}
                                                aria-label={showSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                            >
                                                {showSenha ? <FiEyeOff size={19} /> : <FiEye size={19} />}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="forgot-row">
                                        <button type="button" className="link-btn" onClick={() => { setForgotEmail(email); setMode('forgot'); }}>
                                            Esqueci minha senha
                                        </button>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={handleLogin}
                                        className={`btn-login ${loading ? 'btn-loading' : ''}`}
                                        disabled={loading}
                                    >
                                        {loading ? <div className="spinner"></div> : "Acessar Minha Carteira"}
                                    </button>

                                    <div className="login-divider"><span>não tem acesso?</span></div>

                                    <button type="button" className="btn-atendente" onClick={falarComAtendente}>
                                        <FiMessageSquare size={18} /> Falar com atendente
                                    </button>
                                    <p className="atendente-hint">
                                        Não é possível criar conta por aqui. Fale com o atendente para liberar seu acesso.
                                    </p>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="header-text">
                                    <h2 style={{ textAlign: 'center' }}>Redefinir senha</h2>
                                    <p className="subtitle" style={{ textAlign: 'center' }}>
                                        Informe seu email e enviaremos um link para criar uma nova senha.
                                    </p>
                                </div>

                                <div className="formContainer">
                                    <div className="input-container">
                                        <label htmlFor="forgotEmail">Email</label>
                                        <div className="custom-input-wrapper">
                                            <input
                                                id="forgotEmail"
                                                type="email"
                                                placeholder="seuemail@exemplo.com"
                                                value={forgotEmail}
                                                onChange={(e) => setForgotEmail(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && handleForgot()}
                                            />
                                            <span className="input-icon"><FiMail size={20} /></span>
                                        </div>
                                    </div>

                                    <button
                                        onClick={handleForgot}
                                        className={`btn-login ${forgotLoading ? 'btn-loading' : ''}`}
                                        disabled={forgotLoading}
                                    >
                                        {forgotLoading ? <div className="spinner"></div> : "Enviar link de redefinição"}
                                    </button>

                                    <button type="button" className="link-btn back-btn" onClick={() => setMode('login')}>
                                        <FiArrowLeft size={16} /> Voltar para o login
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </div>
            <Footer />
        </>
    );
};

export default Login;
